import action from './action'

export default {
    getBrands() {
        return action.request('get_welcom_brands')
    }
}
